
const ua = navigator.userAgent;
const isAndroidApp = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
import { Options, Vue } from "vue-class-component";
import Cell from "../../components/InfoCollection/Cell.vue";
import { mapGetters } from "vuex";
import { getProfileItem } from "@/api/aio";
import { compareVersion } from "@/utils/compareVersion";
@Options({
  components: {
    Cell,
  },
  computed: {
    ...mapGetters(["collectionInfo"]),
  },
})
export default class InfoCollectionDetail extends Vue {
  $store;
  $route;
  list: any = [];
  fatherKey: any = "";
  isLoading: boolean = true;
  clientCommonMessage: object = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
  mounted() {
    this.getProfileItemFn();
    // this.getNativeData();
    // window["$eventBus"].addListener("receiveAndroidMsg", this.receiveAndroidMsg);
  }
  // unmounted(){
  //   console.log("destroyed-list")
  //   window["$eventBus"].removeListener("receiveAndroidMsg", this.receiveAndroidMsg);
  // }
  // 从端上获取数据
  // getNativeData() {
  //   window["$mobileNativeSDK"].getData((res) => {
  //     if (!isAndroidApp) {
  //       this.detailNativeData(res);
  //     }
  //   });
  // }
  // 安卓监听消息
  // receiveAndroidMsg(res) {
  //   let androidResult: any = JSON.parse(res);
  //   if (androidResult.event == "getData") {
  //     // 监听获取数据返回
  //     this.detailNativeData(androidResult.dataJson);
  //   }
  // }
  // 处理端上数据
  // detailNativeData(res) {
  //   if (localStorage.getItem("tal_token") !== res.token) {
  //     localStorage.setItem("tal_token", res.token);
  //   }
  //   if (res.service_version) {
  //     localStorage.setItem("service_version", res.service_version);
  //   }
  //   // 获取到端上数据之后开始调用接口
  //   this.getProfileItemFn();
  // }
  async getProfileItemFn() {
    // TODO
    // this.isLoading = false
    // this.infoCollection = ConfigCollection.info_collection
    // this.$store.commit('SET_COLLECTIONINFO', ConfigCollection);
    // console.log(ConfigCollection, 'data')
    document.title = this.$route.query.lable as any;
    // 一级菜单key
    const fatherKey = this.$route.query.collection_key as any;
    this.fatherKey = fatherKey;
    this.isLoading = true;
    await getProfileItem({
      "collection_key":fatherKey
    })
      .then((res) => {
        this.isLoading = false;
        if (res.data.code != "0") {
          this.$dialog.alert({
            message: res.data.message,
            confirmButtonText: "我知道了",
          });
          return;
        }
        // console.log(res, "result");
        let info = res.data.data;
        let list = info.profile_item;
        this.list = list
        if(compareVersion(this.clientCommonMessage["service_version_name"],'1.10.0') === -1 && (fatherKey === "propertyInformation" || fatherKey === "userInformation")){
          for(let i = 0; i < list.length; i++){
            // console.log(list[i])
            if(list[i].key === "user_orders_additional" || list[i].key === "user_orders_records" || list[i].key === "user_address"){
              list[i].collect_status = "0"
              list[i].status_title = "未收集"
            }
          }
          this.list = list
        }
        
        this.isLoading = false;
        // this.$store.commit('SET_COLLECTIONINFO', info);
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
  // getList() {
  //   const collectionInfo = (this as any).collectionInfo;
    
  //   this.list = collectionInfo.info_collection[idx].children;
  // }
}
